import { REASSIGN_PRODUCER } from '../../constants/reducerTypes';

const initialState = {
  reassignProducerResult: null,
};

const reassignProducerReducer = (state = initialState, action) => {
  switch (action.type) {
    case REASSIGN_PRODUCER:
      return {
        ...state,
        reassignProducerResult: action.payload,
      };
    default:
      return state;
  }
};

export default reassignProducerReducer;
